import Vue from 'vue';
import Component from 'vue-class-component';
import { EventEmitter } from 'events';
import { VueClass } from 'vue-class-component/lib/declarations';

import { getEventsMethods, getAnalyticsMethods } from './app';

export const getEmitterHost = (emitter: EventEmitter): VueClass<App.IEmitterHostMixin> => {
	const { offFromHost, onFromHost } = getEventsMethods(emitter);

	@Component
	class EmitterHost extends Vue implements App.IEmitterHostMixin {
		/**
		 * Add listener on event from host
		 */
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		public $onFromHost(listener: (...args: any[]) => void): void {
			onFromHost(listener);
		}

		/**
		 * Remove listener on event from host
		 */
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		public $offFromHost(listener: (...args: any[]) => void): void {
			offFromHost(listener);
		}
	}

	return EmitterHost;
};

export const getAnalytics = (
	emitter: EventEmitter,
	condition?: () => Promise<boolean>
): VueClass<App.IAnalyticsMixin> => {
	const { sendAnalytics } = getAnalyticsMethods(emitter);

	@Component
	class Analytics extends Vue implements App.IAnalyticsMixin {
		/**
		 * Emit event to Google Analytics
		 */
		public async $sendAnalytics(payload?: App.IPayloadData<Analytics.ITypedData>): Promise<void> {
			const needCall = condition ? await condition() : true;

			needCall && sendAnalytics(payload);
		}
	}

	return Analytics;
};
